import { makeStyles } from '@material-ui/core';

const styles = makeStyles({
    rootCalendar: {
        background: '#063f5e',
        borderRadius: '10px',
        minWidth: '161.7px',
        display: 'flex',
        position: 'relative',
        height: '38px',
        margin: '0 13px'
    },
    patientHeaderCalender: {
        minWidth: '160.7px',
        margin: '0 20px',
        display: 'flex',
        position: 'relative',
        alignItems: 'center'
    },
    menuContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    menuIcon: {
        height: '13.5px',
        width: '19.7px',
        margin: '7px 8px 7px 12px',
        '&:hover': {
            cursor: 'pointer'
        }
    },

    date: {
        fontSize: '14px',
        color: '#ffffff'
    },
    patientCalenderDate: {
        fontFamily: 'inherit',
        fontSize: '18px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.72',
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#232733',
        direction: (props) => (props.rtl ? 'rtl' : 'ltr')
    },
    year: {
        fontSize: '13px',
        color: '#ffffff',
        opacity: '0.5'
    },
    datePickerContainer: ({ noAccess }) => ({
        position: 'relative',
        color: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        flex: '1',
        cursor: noAccess ? 'not-allowed' : 'pointer',
        opacity: noAccess ? '0.5' : 1,
        '& input[type="text"]:disabled': {
            opacity: '0 !important'
        }
    }),
    dateYearTxtContainer: {
        padding: '0 13px'
    },
    patientCalenderDateTextContainer: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        '& div:last-child': {
            marginRight: '8px'
        },
        '& svg': {
            margin: '0 15px'
        }
    },
    calenderContainer: {
        position: 'absolute',
        top: 10
    },
    datePicker: {
        opacity: '0',
        cursor: 'pointer',
        '&:disabled': {
            cursor: 'not-allowed'
        }
    },

    dateContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: '1'
    }
});

export default styles;
